/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Visitors_Chart_AriaInputs */

const en_directory_rails_visitors_chart_aria = /** @type {(inputs: Directory_Rails_Visitors_Chart_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitor trend over the last 30 days`)
};

const zh_directory_rails_visitors_chart_aria = /** @type {(inputs: Directory_Rails_Visitors_Chart_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近 30 天访问趋势`)
};

/**
* | output |
* | --- |
* | "Visitor trend over the last 30 days" |
*
* @param {Directory_Rails_Visitors_Chart_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_visitors_chart_aria = /** @type {((inputs?: Directory_Rails_Visitors_Chart_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Visitors_Chart_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_visitors_chart_aria(inputs)
	return zh_directory_rails_visitors_chart_aria(inputs)
});
export { directory_rails_visitors_chart_aria as "directory.rails.visitors_chart_aria" }